import { render, staticRenderFns } from "./SynchronizedWaypoint.vue?vue&type=template&id=453141a3&"
import script from "./SynchronizedWaypoint.vue?vue&type=script&lang=js&"
export * from "./SynchronizedWaypoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports